import NeoNewsExpanded from "@/components/news-expanded";
import MorePersonIdentifier from "@/components/more-person-identifier";
import AdverseMediaExpand from "@/components/adverse-media-expand";
import NeoUniCourtExpand from "../uni-court/expand.vue";

export default {
    name: "result-expanded",
    components: {NeoNewsExpanded, MorePersonIdentifier, AdverseMediaExpand, "neo-uni-court-expand": NeoUniCourtExpand},
    props: {
        content: {
            type: Object,
            default: {},
        },
        cardComponent: {
            type: String,
            required: true,
        },
        expandedLoading: {
            type: Boolean,
            default: false,
        },
        allLanguages: {
            type: Array,
            default: () => [],
        },
        isResultExpanded: {
            type: Boolean,
            default: false,
        },
        isSavedLoading: {
            type: Object,
            default: () => {},
        },
        isOldVersionSelected: {
            type: Boolean,
            default: false,
        },
        showFullViewBtn: {
            // TODO: ad this prop to other cardComponent's
            type: Boolean,
            default: true,
        },
        names: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
